import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./design/global.css";
import { App } from "./app";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
